module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/fotress-891679c3e53b7e437c838eacd7759ae1.png";